import React from 'react';
import { ShopItem } from '../ShopItem.interface';
import './ShopCard.css'
import imagePlaceholder from 'assets/img/DT_bubak.png';
import { environments } from 'environments/environments';
import PhotoDisplay from 'libs/components/PhotoDisplay/PhotoDisplay';
import { GalleryImage } from 'components/Main/PhotoSection/Gallery.interface';

interface Props { item: ShopItem }
interface State { [key: string]: any }

export default class ShopCard extends React.Component<Props, State> {
  state = {
    photoPreviewActive: false,
    imageWidth: 0,
    imageHeight: 0
  }

  componentDidMount(): void {
    this.measureImage();
  }


  measureImage() {
    const image = this.props.item.image || imagePlaceholder;
    const virtualImage = new Image();
    virtualImage.onload = () => {
      const [width, height] = [Math.max(virtualImage.naturalWidth, 100), Math.max(virtualImage.naturalHeight, 100)];
      // console.log(width, height);
      this.setState({ imageWidth: width, imageHeight: height });
    }
    virtualImage.src = this.getImageURL(image);
    virtualImage.remove();
  }


  getImageURL(imageURL: string) {
    if (imageURL.includes('http')) {
      return imageURL;
    }
    return `${environments.server}${imageURL}`;
  }


  render() {
    const item = this.props.item;
    const itemDescription = item.description.split('\n').map((line, index) => <p key={index}>{line}</p>);
    const priceInfo = item.priceInfo || 'Kč'
    const image = item.image
      ? item.image.includes('http')
        ? item.image
        : environments.server + item.image
      : imagePlaceholder;
    const ratioClass = item.imageRatio
      ? item.imageRatio === 'w'
        ? 'suvenyr-image suvenyr-image-wider'
        : 'suvenyr-image suvenyr-image-higher'
      : 'suvenyr-image';

    const imageDisplay: GalleryImage = {
      id: 0,
      filename: image,
      height: this.state.imageHeight,
      width: this.state.imageWidth,
      category: 'ILUSTRACE',
      gallery: 0,
      order: 0,
      public: 1,
      text: item.description,
      time: Date.now()
    };

    return (
      <div className="suvenyr-card">
        <img className={ratioClass} alt="Obrázek suvenýru" src={image} onClick={() => this.setState({ photoPreviewActive: true })} />
        <div className="suvenyr-info">
          <div>
            {itemDescription}
            {item.price
              ? <p>Cena: <span className="suvenyr-price">{item.price},-</span> {priceInfo}</p>
              : null
            }
            <p className="suvenyr-note">{item.note}</p>
          </div>
        </div>
        {this.state.photoPreviewActive
          ? <PhotoDisplay activePhoto={0} photoList={[imageDisplay]} close={() => this.setState({ photoPreviewActive: false })} />
          : null
        }
      </div>
    );
  }
}